<template>
	<div class="panel bgPanel mt1x cb mr1x ml1x">
		<div class="title title-bg">
			<span :title="getLanguageStr('word1818','电池实时')">{{getLanguageStr("word1818","电池实时")}}</span>
			<!-- <div class="tool">
				<button class="more fa fa-angle-right tra-fast"></button>
			</div> -->
		</div>
		<div>
			<div class="clearfix fL_E w50pct_E pl2x_E pr2x_E">
				<div class="mt1x">
					<div class="bdSub-bottom pb2x dpIB_E vaT_E ">
						<div class="taC mr1x">
							<div class="icoSys h3x w3x" :class="{bgPrimary:(Math.abs(stationInfo.batteryPower)>0)?true:false,bgLight:(stationInfo.batteryPower==null||stationInfo.batteryPower==0)?true:false}">
								<Icon :name="getBatteryIco(stationInfo.batterySoc)" class="w3x h2x dpB" :class="{fWhite:(Math.abs(stationInfo.batteryPower)>0)?true:false,fSub:(stationInfo.batteryPower==null||stationInfo.batteryPower==0)?true:false}" :sizeBase="'xs'" />
							</div>
							<div class="mt05x">
								<div :title="stationInfo.batteryStatus?getTypeText(stationInfo.batteryStatus,'batteryStatus'):'--'">{{stationInfo.batteryStatus?getTypeText(stationInfo.batteryStatus,'batteryStatus'):'--'}}</div>
								<div>
									<Icon v-if="stationInfo.batteryStatus=='CHARGE'" name="dirArrow-l" class="w2x h1x fMain" />
									<Icon v-if="stationInfo.batteryStatus=='DISCHARGE'" name="dirArrow-r" class="w2x h1x fMain" />
								</div>
								<div><span class='cMain'>{{stationInfo.batterySoc!=null?floatFix(stationInfo.batterySoc,2)+"%":"--"}}</span></div>
							</div>
						</div>
						<ul class="fL_E clearfix pl2x mr3x_E">
							<li>
								<div class="mb1x" :title="$t('plant366',['电池功率'])">{{$t("plant366",["电池功率"])}}</div>
								<div class="cMain">
									<span :title="convertData(Math.abs(stationInfo.batteryPower),2,'','W')[0]">
										<span v-if="stationInfo.batteryPower==null">--</span>
										<span v-else><span class="fs14x">{{convertData(Math.abs(stationInfo.batteryPower),2,'','W')[1]}}</span>
									   {{convertData(Math.abs(stationInfo.batteryPower),2,'','W')[2]}}</span>
									</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="clearfix fL_E w50pct_E pl2x_E pr2x_E">
				<div>
					<div class="pt2x pb2x tableSys vaM_E">
						<div class="w40pct bdSub-right">
							<div class="dpIB">
								<div class="mb2x" :title="$t('word548',['当日充电量'])">{{$t("word548",["当日充电量"])}}</div>
								<div class="cMain" :title="convertData(stationInfo.chargeValue,2,'k','Wh')[0]">
									<span class="fs16x">{{convertData(stationInfo.chargeValue,2,'k','Wh')[1]}}</span>
									{{convertData(stationInfo.chargeValue,2,'k','Wh')[2]}}
								</div>
							</div>
						</div>
						<div class="pl3x">
							<div class="mb1x"><span class="mr2x" :title="$t('word550',['当月充电量'])">{{$t("word550",["当月充电量"])}}</span><span :title="convertData(stationInfo.chargeMonth,2,'k','Wh')[0]">{{convertData(stationInfo.chargeMonth,2,'k','Wh')[0]}}</span></div>
							<div class="mb1x"><span class="mr2x" :title="$t('word552',['当年充电量'])">{{$t("word552",["当年充电量"])}}</span><span :title="convertData(stationInfo.chargeYear,2,'k','Wh')[0]">{{convertData(stationInfo.chargeYear,2,'k','Wh')[0]}}</span></div>
							<div><span class="mr2x" :title="$t('word546',['累计充电量'])">{{$t("word546",["累计充电量"])}}</span><span :title="convertData(stationInfo.chargeUploadTotal,2,'k','Wh')[0]">{{convertData(stationInfo.chargeUploadTotal,2,'k','Wh')[0]}}</span></div>
						</div>
					</div>
				</div>
				<div>
					<div class="pt2x pb2x tableSys vaM_E">
						<div class="w40pct bdSub-right">
							<div class="dpIB">
								<div class="mb2x" :title="$t('word549',['当日放电量'])">{{$t("word549",["当日放电量"])}}</div>
								<div class="cMain" :title="convertData(stationInfo.dischargeValue,2,'k','Wh')[0]">
									<span class="fs16x">{{convertData(stationInfo.dischargeValue,2,'k','Wh')[1]}}</span>
									{{convertData(stationInfo.dischargeValue,2,'k','Wh')[2]}}
								</div>
							</div>
						</div>
						<div class="pl3x">
							<div class="mb1x"><span class="mr2x" :title="$t('word551',['当月放电量'])">{{$t("word551",["当月放电量"])}}</span><span :title="convertData(stationInfo.dischargeMonth,2,'k','Wh')[0]">{{convertData(stationInfo.dischargeMonth,2,'k','Wh')[0]}}</span></div>
							<div class="mb1x"><span class="mr2x" :title="$t('word553',['当年放电量'])">{{$t("word553",["当年放电量"])}}</span><span :title="convertData(stationInfo.dischargeYear,2,'k','Wh')[0]">{{convertData(stationInfo.dischargeYear,2,'k','Wh')[0]}}</span></div>
							<div><span class="mr2x" :title="$t('word547',['累计放电量'])">{{$t("word547",["累计放电量"])}}</span><span :title="convertData(stationInfo.dischargeUploadTotal,2,'k','Wh')[0]">{{convertData(stationInfo.dischargeUploadTotal,2,'k','Wh')[0]}}</span></div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div class="pl2x pr2x">
		</div>
	</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as equipmentApi from '@/api/maintain/plant/list'
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
export default {
  name: 'GridBattery',
  components: {Loading},
  data () {
	return {
	  isLoading: false,
	  stationInfo: {}
	}
  },
  methods: {
	getLanguageStr,
	getTypeText: lib.getTypeText,
	floatFix: lib.floatFix,
	convertData: lib.convertData,
	getBatteryIco: lib.getBatteryIco,
	show (data) {
	  if (data.stationInfo) {
		this.stationInfo = data.stationInfo
		setTimeout(() => {
		  this.isLoading = false
		}, 500)
	  } else {
		this._getList(data.stationId)
	  }
	},
	_getList (id) {
	  this.isLoading = true
	  equipmentApi.StationInfo(id).then(res => {
		this.isLoading = false
		this.stationInfo = res
	  }, error => {
		this.isLoading = false
		!_.isEmpty(error) && this.$notify(error)
	  })
	}

  }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GridBattery.vue